import './Sort.scss'
import { connectSortBy } from 'react-instantsearch-dom'

import OptionIcon from './OptionIcon'

const highlightedStyle = {
  background: 'rgba(0, 140, 255, 0.1)',
  border: '1px solid #008CFF',
}
const normalStyle = {
  background: '#F2F4F8',
  border: 'none',
}

let label: any
const OptionValue = (props: any) => {
  if (label === undefined) {
    label = props.initialVal
  }
  return <span>{label}</span>
}

const SortBy = ({
  items,
  refine,
  createURL,
}: {
  items: any
  refine: any
  createURL: any
}) => (
  <div className="mobileSort">
    <ul className="list">
      {items.map((item: any) => (
        <li
          key={item.value}
          className="mobileSortOption"
          style={item.isRefined ? highlightedStyle : normalStyle}
        >
          <a
            className="options"
            href={createURL(item.value)}
            style={{ color: item.isRefined ? '#008CFF' : '#232A2D' }}
            onClick={event => {
              event.preventDefault()
              refine(item.value)
            }}
          >
            <div className="mobileOptionData">
              {OptionIcon(item)}
              <span className="mobileOptionLabel">{item.label}</span>
            </div>
          </a>
        </li>
      ))}
    </ul>
  </div>
)

const Sort = connectSortBy(SortBy)

export { Sort, OptionValue }
